__turbopack_context__.v({
  "checkbox": "checkbox-module__kpla7W__checkbox",
  "indicator": "checkbox-module__kpla7W__indicator",
  "label": "checkbox-module__kpla7W__label",
});
